var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-border-box-8',[_c('div',{staticClass:"hd"},[_vm._v("未来物业")]),_c('dv-scroll-board',{attrs:{"config":_vm.config}}),_c('dv-decoration-2',{staticStyle:{"height":"10px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }